import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthenticationState } from './auth.models';

export const getLayoutState = createFeatureSelector<AuthenticationState>('auth');

export const getUser = createSelector(
    getLayoutState,
    (state: AuthenticationState) => state.user
);

export const getAvatarStatus = createSelector(
    getLayoutState,
    (state: AuthenticationState) => state.isAvatarProcessing
);

export const getisLoggedIn = createSelector(
    getLayoutState,
    (state: AuthenticationState) => state.isLoggedIn
);

export const getError = createSelector(
    getLayoutState,
    (state: AuthenticationState) => state.error
);

export const selectDataLoading = createSelector(
    getLayoutState,
    (state: AuthenticationState) => state.loading
);

export const getIsProfileUpdated = createSelector(
    getLayoutState,
    (state: AuthenticationState) => state.isProfileUpdated
);